import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newPurchaseorder({ state }) {
    let purchaseDetails = {
      grand_total: $(".grand_total").val(),
      purchase_order_items: state.purchase_order_items
    };
    console.log(purchaseDetails);
    
    $(".creatingPurchaseorder").hide();
    $(".creatingPurchaseorderLoader").show();
    baseurl.post(rt.newPurchaseorder, purchaseDetails).then(res => {
      $(".creatingPurchaseorder").show();
      $(".creatingPurchaseorderLoader").hide();
      $(".form-control").val("");

      if (res.data.code === 200) {
        //success code
        suc.purchaseorderCreateSuccess();
        router.push("/managepurchaseorders");
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //error on creating data
        ers.errorCreatingPurchaseorder();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadPurchaseorder({ commit }) {
    baseurl.get(rt.loadPurchaseorders).then(res => {
      $(".purchaseLoaders").hide();

      //checking for response codes from backend api

      if (res.data.code === 200) {
        commit("STORE_PURCHASEORDERS", res.data.purchaseorders);
      } else if (res.data.code === 404) {
        //error on loading data
        ers.errorLoadingPurchaseorder();
      } else if (res.data.code === 405) {
        //no permission to read
        commit("STORE_PURCHASEORDERS", []);
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  viewPurchaseorder({ commit }, id) {
    let purchaseDetails = {
      purchaseorder_id: id
    };

    baseurl.post(rt.viewPurchaseorders, purchaseDetails).then(res => {
      //checking for responses codes from backed api

      if (res.data.code === 200) {
        //success codes
        commit("STORE_PURCHASEORDER_GOODS", res.data.purchaseorder);
        commit("STORE_PURCHASEORDER_ITEMS", res.data.purchase_order_item);
        var voucher = [];

        for (let i = 0; i < res.data.purchaseorder.length; i++) {
          voucher = res.data.purchaseorder[i];
        }
        let rows = [];
        let logo =
           "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/4gHYSUNDX1BST0ZJTEUAAQEAAAHIAAAAAAQwAABtbnRyUkdCIFhZWiAAAAAAAAAAAAAAAABhY3NwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAA9tYAAQAAAADTLQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAlkZXNjAAAA8AAAACRyWFlaAAABFAAAABRnWFlaAAABKAAAABRiWFlaAAABPAAAABR3dHB0AAABUAAAABRyVFJDAAABZAAAAChnVFJDAAABZAAAAChiVFJDAAABZAAAAChjcHJ0AAABjAAAADxtbHVjAAAAAAAAAAEAAAAMZW5VUwAAAAgAAAAcAHMAUgBHAEJYWVogAAAAAAAAb6IAADj1AAADkFhZWiAAAAAAAABimQAAt4UAABjaWFlaIAAAAAAAACSgAAAPhAAAts9YWVogAAAAAAAA9tYAAQAAAADTLXBhcmEAAAAAAAQAAAACZmYAAPKnAAANWQAAE9AAAApbAAAAAAAAAABtbHVjAAAAAAAAAAEAAAAMZW5VUwAAACAAAAAcAEcAbwBvAGcAbABlACAASQBuAGMALgAgADIAMAAxADb/2wBDAAMCAgICAgMCAgIDAwMDBAYEBAQEBAgGBgUGCQgKCgkICQkKDA8MCgsOCwkJDRENDg8QEBEQCgwSExIQEw8QEBD/2wBDAQMDAwQDBAgEBAgQCwkLEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBD/wAARCACIAM0DASIAAhEBAxEB/8QAHQABAAICAwEBAAAAAAAAAAAAAAYHAQgDBAUJAv/EADsQAAEDAwIDBgQDBAsAAAAAAAABAgMEBREGBxIhMQgTQVFhgRQicZEygqEVF1JiIyQmM0JXcpKVsdH/xAAbAQEAAgMBAQAAAAAAAAAAAAAABQYCAwQHAf/EADMRAAIBAwIDBgQFBQEAAAAAAAABAgMEEQUhEjFBBlFhcZGxE6HB0RYzNIGCIiMyQmJy/9oADAMBAAIRAxEAPwD6pgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGMogBkAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA8nUlddLZapq+00cdXNB87oXqqcTE64x4+J6xhWovUyi1GSbWTCpFzi4p4ff3FfW7eSyzo1txt9TSuVPmVuHtT/pf0JNbtbaYuqNSkvNNxvTKMkdwO+y4InrPa5LhNJdNPKyGd2XSUzuTHr5tX/Cvp0KvuFsrrZMtPc6KWnf0xKzGfp5lioafYahHNCTjLu549fuU+51bVdKnw3MFOPR4xn91y/dGyscrJWJJG9r2rzRzVyi+5+kXKmtdBd7rbJElt9xqKdyck4JFRMeWOhJbdurqyiViVE0NYxq80ljwqp9UwaqvZ64h+XJS+Rvt+1ttPatBxfqvo/kXgCtLfvPRv4W3S0TRL4vgej0+y4UlFu3A0pc0YkN2jikf0jm+RyL78iMrWF1Q/zg/f2Jq31exufy6i/fb3JGDjhniqGJLBKyRi9HMVFRfdDkOMkU090AAD6AAAAAAAAAAAAAAAAAAAAAAAAYwnka175Xzeva66Sahs9xivekal6vWGuomTpRucvON64R/Bn8Ls8s48DZU4Kmjp62nfS1lPHPDK1WSRyNRzXNXqiovVDv029jYV1UqU1OPVNdPDufc0Q2uaVPVrR0aNaVKfOMovk/FdU+qZpbQ9piy1C/2k2qoHomOF1srHwL65ReRKbfuxsReHtbNdtQWJzm8TkqaVJo2r5I5mVX7Ek3W7Le2jqOr1La76zSDY/wCkmdM5HULMr1VFVFjTK+C49CnX9mLWFYxanSuqtK3+B39y6luLUdKnoipjPpk9Ft63Z2/p8dOpOi+7LwvXij8zxi8t+2uj1XTq0YXMejUY5a/jwz9S5bXRaI1GjU0xufYK2WROJkEsvcyKnq1y5RfY9Kp2y1fA1HR0EVS1ydYJmuT9cGtd27PG8dpi+IqtCVkzU5/1V7J1T2Yqr+h50Um8uhU7+FdXWVrlRc8M7GqqfXkb1pKrb2N7CfhLHvFr2Ob8T1LbbVNMqU33x4l8pRfubJ/B6s06vepTXOhRqqiOaj2on25HrWzdHVlvVGzVUdbG1MKydqZX8ycyhbV2qt5bG/4e5XKjuLeBG91cKJEdjzy3hVc+uSaW3tZaVurI4tb7YRK5zeCSooZGrhPNGuRF/U4brQdQSzWto1F3xaz88Ml7Dtjo0niheTovuqRaXrHK9S87TvFbKhWx3i3y0i8syRr3jM+PLqifcnNtu1uu9MlXbqyKeJeXEx2cL5Kngvoa6W/cDYLVnBFa9V1WnquVPliuUStiRU8FcuWp/uJLTWnU+leDUWna2C4UK/N8RQy97FI3+dqeGPt5lYvNIop8KUqU+immk/Jv7svWm9oq1RcfFGvT6yptNrzS39Ui8smTyNM3+n1JaILrTpw958r2fwPTqh3rhcaC00j6+6VsNJTRq1HzTPRjG8TkamVXkmVVE9ytyhKEnCS3WxdKdWFSCqRezWc+B2QccU0U7GywvbIx6Za5qorVT0VD9+xjyNieeRkGMoEXIBkAAAAAAAAAAAAAAAAAHWuFBRXShqLbcaSKppaqN0U0MrUcyRjkwrVReqKhp1ux2Mb7aK6bUGz1Q6opnPWRLW+bup4FXwikVURzU8lVF8MqbmjhQkdO1S50ufHbvZ80+T80Rep6Ra6tBQuFuuTWzXkz5ut1V2kNu6qGkmuWtbY6BuY4KlkskatT+VyKjkPctnbF3tsrFpbldLZcFR2VS4UDWvRPL5FZ+p9BuFPHn9Tyq/SOlLpIsty0zaqt7urpqON7l91TJOvtJZ1/1NnF+K2+n1K7+Fr23/S3sku55f1+hp1F2x7DqBI4de7N2a5RK3E0lPI1z1XzRJG9PTiO9R7j9jzWOXag0NW6aqOFUVY4ntZ7LC5UVfymyt32P2hvsiTXTbqxTPROFHJSNYuPy4IpfOyZsZeVc5mk3256t4UdQVUkSJ68OVbn2Mqer6Uvyo1aT/4n92aa/Z7U6q/v/Brf+4L3x9Sm12a7O2su6boDeiGkqJmq5tPWzMervThfwOacFJtbv9spO2/6AuMd8ti4kkbbpO9hmbno+Bea/VuV6kzvPYS2/qmt/Ymrb3QKn4u/bHUI72w3BG6Ts69onaKdly2r1/Bc4IXqq0DpXRNexFyjVieqsdnyRU+pK09dhWh8FXSqRf8ApWjs/wCS5eZXLjsbTpVFcRtHRmuU6E91/B7PxWxeux2tbJrvT1Ve7ZSfs+qWoRlxtq8vhalE+bCLzRHfiQnWoLFatT2St0/fKRlVQXCF0FRE7o5jk5/RfFF8FKu2P1VT6tut6rb7pWTTGtqaOGmv1uVnAyZUVVjqW/xI5FVM88YxlS1brdLfZbdVXW61UdNR0cTp55pFw1jGplVVfoUm/jwXcvhprdYWc48mua7n1R6RpDk9PiriSls03jCfPdro+9dHk+c+4bte7Ha5vG3+nNe3ymt9HK2Sm7msexHQvajmZRFwioi4XHimSP8A74t2v8y9Sf8AIP8A/TO5urqvdLcu76lo6WaV11q+Cip2MV0ixNRGRtRqc1VWoiqieKqW3t52K9dalp47jra6Raap5Ey2mRiT1SpjkqplGs+irk9TlWsbC1p1NSUVNpZyk23jfbGWeUQoX2oXdSnpnE4KTxhtJLO2+cEA0x2kd6tLVLZqbXNbXxo9HOguWKmN6fwrxfMif6VQ3U2J32sm81ifJFCyhvlCifH29X54c8kkjXq5ir7p0UgVD2GNro6VsVfqDUVROn4pWTxxI76N4Fx9z3tI9lHSG3mpbfqzRWqr/RXCik+fv5Y5o6iFfxxPajW8lT15LhSn6zfaHf038CLhUXJqOE/B/fBc9DsNf02qvjtTpvmnLLXis9V57l4ouUyZMN6czJTS9gAAAAAAAAAAAAAAAAAAAAAAAGMJ5DkvkZI9fNEWvUUz3XSuuzoZG8D6WK4yxQuTyVjFQ+xSzvyMZuSX9KyyPa+3S2r28qUvGpr7RtusUDooqemxNWysVc8CRs+ZUzzTOERSidXRb6dqSpbarRYZ9H6Fa9Hd5ckWN9Vjo97U+Z/mjERG+OVU2M05tXt3pKofV6d0ZaaKok5unZTo6Vfzuyv6kqx05dCTt76lYvjt4ZmuUpdPKPLPi2yIudOr6guC5nw0+sY9fOT3x4JIrPaPs/6C2jp0mtNF8dd3txNc6tqOmX0Z4Rt9E91Us3CeRkHDXuKt1UdWtJyk+rJK2tqNpTVKhFRiuiMAyDSbwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD//2Q==";

        const tblHeader = [
          { text: "Description" },
          { text: "Unit" },
          { text: "Quantity" },
          { text: "U/price" },
          { text: "Remark" },
          { text: "Total", alignment: "right" }
        ];
        // table header
        rows.push(
          tblHeader.map(d => {
            return {
              text: typeof d.text === "string" ? d.text : d.text + "",
              alignment:
                typeof d.alignment === "undefined" ? "left" : d.alignment,
              style: "tableHeader",
              border: [false, true, false, false]
            };
          })
        );
        // table body
        const reportData = res.data.purchase_order_item;
        for (let i = 0; i < reportData.length; i++) {
          let array = [];
          const rp = reportData[i];

          // expenses name
          array.push({
            text: rp.product_description
          });

          array.push({
            text: rp.product_measurement
          });
          // payee name
          array.push({
            text: rp.qty
          });

          // payee description
          array.push({
            text: rp.unit_price
          });

          array.push({
            text: rp.remarks
          });
          array.push({
            text: rp.total_price,
            alignment: "right"
          });

          //payee no

          //append table
          rows.push(
            array.map(d => {
              return {
                text: typeof d.text === "string" ? d.text : d.text + "",
                alignment:
                  typeof d.alignment === "undefined" ? "left" : d.alignment,
                border: [false, false, false, false]
              };
            })
          );
        }
        var dd = {
          pageOrientation: "potrait",
          pageSize: "A4",
          footer: {
            columns: [
              {
                text: "...::: Garage Master :::...",
                alignment: "center",
                bold: true,
                fontSize: 18
              }
            ]
          },
          content: [
            {
              columns: [
                {
                  image: logo,
                  width: 200
                },
                [
                  {
                    text: "Purchase order",
                    color: "#333333",
                    width: "*",
                    fontSize: 28,
                    bold: true,
                    alignment: "right",
                    margin: [0, 0, 0, 15]
                  },
                  {
                    stack: [
                      {
                        columns: [
                          {
                            text: "Purchaseorder No.",
                            color: "#aaaaab",
                            bold: true,
                            width: "*",
                            fontSize: 12,
                            alignment: "right"
                          },
                          {
                            text: voucher.purchase_order_no,
                            bold: true,
                            color: "#333333",
                            fontSize: 12,
                            alignment: "right",
                            width: 100
                          }
                        ]
                      },
                      {
                        columns: [
                          {
                            text: "Date Issued",
                            color: "#aaaaab",
                            bold: true,
                            width: "*",
                            fontSize: 12,
                            alignment: "right"
                          },
                          {
                            text: voucher.purchase_order_date,
                            bold: true,
                            color: "#333333",
                            fontSize: 12,
                            alignment: "right",
                            width: 100
                          }
                        ]
                      }
                    ]
                  }
                ]
              ]
            },
            {
              columns: [
                {
                  text: "Address",
                  color: "#00000",
                  bold: true,
                  margin: [0, 4, 0, 4]
                },
                {
                  text: "Email",
                  color: "#00000",
                  bold: true,
                  margin: [0, 4, 0, 4]
                },
                {
                  text: "Tel",
                  color: "#00000",
                  bold: true,
                  margin: [0, 4, 0, 4]
                }
              ]
            },
            {
              columns: [
                {
                  text:
                    "P.O Box: 85192 - 80100 Mombasa, Kenya \n New Canon towers 7th Floor  ",
                  style: "invoiceBillingAddress"
                },
                {
                  text: "info@brihantransport.co.ke",
                  style: "invoiceBillingAddress"
                },
                {
                  text:
                    "+254 733 324 342 \n +254 715 015 744 ",
                  style: "invoiceBillingAddress"
                }
              ]
            },
            "\n\n",
            {
              layout: {
                defaultBorder: false,
                hLineWidth: function(i, node) {
                  return 1;
                },
                vLineWidth: function(i, node) {
                  return 1;
                },
                hLineColor: function(i, node) {
                  if (i === 1 || i === 0) {
                    return "#bfdde8";
                  }
                  return "#eaeaea";
                },
                vLineColor: function(i, node) {
                  return "#eaeaea";
                },
                hLineStyle: function(i, node) {
                  // if (i === 0 || i === node.table.body.length) {
                  return null;
                  //}
                },
                // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
                paddingLeft: function(i, node) {
                  return 10;
                },
                paddingRight: function(i, node) {
                  return 10;
                },
                paddingTop: function(i, node) {
                  return 2;
                },
                paddingBottom: function(i, node) {
                  return 2;
                },
                fillColor: function(rowIndex, node, columnIndex) {
                  return "#fff";
                }
              },

              table: {
                headerRows: 1,
                widths: [100, 50, 50, 50, 50, 100],
                body: rows
              }
            },
            "\n",
            "\n\n",
            {
              layout: {
                defaultBorder: false,
                hLineWidth: function(i, node) {
                  return 1;
                },
                vLineWidth: function(i, node) {
                  return 1;
                },
                hLineColor: function(i, node) {
                  return "#eaeaea";
                },
                vLineColor: function(i, node) {
                  return "#eaeaea";
                },
                hLineStyle: function(i, node) {
                  // if (i === 0 || i === node.table.body.length) {
                  return null;
                  //}
                },
                // vLineStyle: function (i, node) { return {dash: { length: 10, space: 4 }}; },
                paddingLeft: function(i, node) {
                  return 10;
                },
                paddingRight: function(i, node) {
                  return 10;
                },
                paddingTop: function(i, node) {
                  return 3;
                },
                paddingBottom: function(i, node) {
                  return 3;
                },
                fillColor: function(rowIndex, node, columnIndex) {
                  return "#fff";
                }
              },
              table: {
                headerRows: 1,
                widths: [400, 100],
                body: [
                  [
                    {
                      text: "Total Amount",
                      bold: true,
                      fontSize: 20,
                      alignment: "right",
                      border: [false, false, false, true],
                      margin: [0, 5, 0, 5]
                    },
                    {
                      text: Number(voucher.grand_total)
                        .toFixed(2)
                        .replace(/\d(?=(\d{3})+\.)/g, "$&,"),
                      bold: true,
                      fontSize: 18,
                      alignment: "right",
                      border: [false, false, false, true],
                      fillColor: "#f5f5f5",
                      margin: [0, 5, 0, 5]
                    }
                  ]
                ]
              }
            },
            "\n\n",
            {
              columns: [
                  {
                      text:'',
                  },
                  {
                      stack: [
                          { 
                              text: '_________________________________',
                              style:'signaturePlaceholder'
                          },
                          { 
                              text: 'Prepared by:',
                              style:'signatureName'
                              
                          },
                          { 
                              text: voucher.fullname,
                              style:'signatureJobTitle'
                              
                          }
                          ],
                     width: 300
                  },
                  {
                      stack: [
                          { 
                              text: '_________________________________',
                              style:'signaturePlaceholder'
                          },
                          { 
                              text: 'Checked by:',
                              style:'signatureName'
                              
                          },
                          { 
                              text: 'Rezene Ghebrendias',
                              style:'signatureJobTitle'
                              
                          }
                          ],
                     width: 300
                  },
                 
              ]
          },
          ],
          styles: {
            tableHeader: {
              bold: true,
              alignment: "center",
              color: "#fff",
              margin: [0, 4, 0, 4],
              fillColor: "#246DE3"
            },
            notesTitle: {
              fontSize: 10,
              bold: true,
              margin: [0, 50, 0, 3]
            },
            notesText: {
              fontSize: 10
            },
            signaturePlaceholder: {
              margin: [0, 70, 0, 0]
            },
            signatureName: {
              bold: true,
              alignment: "left"
            },
            signatureJobTitle: {
              italics: true,
              fontSize: 10,
              alignment: "Left"
            }
          },
          defaultStyle: {
            columnGap: 20
            //font: 'Quicksand',
          }
        };

        pdfMake.createPdf(dd).print();
      } else if (res.data.code === 404) {
        //error on creating data
        ers.errorLoadingPurchaseorder();
      } else if (res.data.code === 405) {
        //no permission to create
        ers.noPermissionToRead();
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  updatePurchaseorder({ state }) {
    let purchaseDetails = {
      grand_total: $(".grand_total").val(),
      purchaseorder_id: $(".purchaseorder_id").val(),
      purchase_order_item: state.purchase_order_item
    };
    console.log(purchaseDetails);
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/purchaseorders/actions.js